import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1.314;

const EmailIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 23;

	if (size) {
		height = size;
	}
	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 30 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M26.3377 0.584717H3.66853C1.64494 0.584717 0 2.22966 0 4.25325V19.7467C0 21.7703 1.64494 23.4153 3.66853 23.4153H26.3315C28.3551 23.4153 30 21.7703 30 19.7467V4.25945C30.0062 2.23587 28.3613 0.584717 26.3377 0.584717ZM28.3302 19.7467C28.3302 20.8454 27.4364 21.7393 26.3377 21.7393H3.66853C2.56983 21.7393 1.67598 20.8454 1.67598 19.7467V4.25945C1.67598 3.16076 2.56983 2.2669 3.66853 2.2669H26.3315C27.4302 2.2669 28.324 3.16076 28.324 4.25945V19.7467H28.3302Z"
				fill={color}
			/>
			<path
				d="M18.9199 11.8077L26.257 5.22789C26.5984 4.91753 26.6294 4.38991 26.319 4.0423C26.0087 3.70089 25.4811 3.66986 25.1334 3.98022L15.0155 13.0615L13.0416 11.2987C13.0354 11.2925 13.0292 11.2862 13.0292 11.28C12.9857 11.2366 12.9423 11.1993 12.8926 11.1621L4.86033 3.97401C4.51272 3.66365 3.9851 3.69469 3.67473 4.0423C3.36436 4.38991 3.3954 4.91753 3.74301 5.22789L11.167 11.8635L3.77405 18.7847C3.43885 19.1013 3.42023 19.6289 3.7368 19.9703C3.9044 20.1441 4.12786 20.2372 4.35133 20.2372C4.55617 20.2372 4.76101 20.1627 4.9224 20.0137L12.4271 12.9933L14.4631 14.812C14.6244 14.9548 14.8231 15.0231 15.0217 15.0231C15.2204 15.0231 15.4252 14.9486 15.5804 14.8058L17.6722 12.9312L25.1334 20.02C25.2948 20.1751 25.5059 20.2496 25.7107 20.2496C25.9342 20.2496 26.1514 20.1627 26.319 19.9889C26.6356 19.6537 26.6232 19.1199 26.288 18.8033L18.9199 11.8077Z"
				fill={color}
			/>
		</svg>
	);
};

export default EmailIcon;
